import { loginTypes } from 'config/loginTypes';
import { notQualifiedTypes } from 'config/notQualifiedTypes';
import { verifyKKboxMemberQualify, verifyLineFriend, verityMemberQualification } from 'api/client';
import {
    isErrOfCyberbizEcLimit,
    isErrOfApiNameListLimit,
    isErrOfEnterpriseBindLine,
    isErrOfNewRegisterMemberLimit,
    isErrOfMemberTier,
    isErrOfAchievementLevel
} from 'client/utils/errorObjectChecker';

// 透過 promo setting 判斷是否需要進行登入者資格檢查
export default async function getLoginUserNonQualifyType(state) {
    const {
        promo: { uuid: promoUUID },
        settingPromo: {
            loginMethod,
            // ageLimitMax,
            // ageLimitMin,
            // birthdayLimit,
            friendLimit,
            enableQualificationMemberCyberbiz,
            enableQualificationRestrictedList,
            enableQualificationRegistrationDate,
            enableQualificationMemberTier,
            qualificationAccountLinkPlatformLinkTarget,
            enableQualificationAchievementLevel // 成就等級限制
        },
        partner: { thirdPartyQualificationMemberLevelPlatform = '' }
        // userGameResultRecords = []
    } = state;

    // const facebookVerify =
    //     loginMethod === loginTypes.FACEBOOKLOGIN && (ageLimitMax || ageLimitMin || birthdayLimit);
    const shouldCheckLineFriend = loginMethod === loginTypes.LINELOGIN && friendLimit === 1;
    if (shouldCheckLineFriend) {
        const { payload: isFriendShip } = await verifyLineFriend(promoUUID);
        if (!isFriendShip) {
            return { notQualifiedType: notQualifiedTypes.LINE.FRIEND };
        }
    }

    const shouldCheckIsCyberbizECMember =
        loginMethod === loginTypes.ENTERPRISELOGIN && Boolean(enableQualificationMemberCyberbiz);
    const shouldCheckApiNameListLimit =
        loginMethod === loginTypes.ENTERPRISELOGIN && Boolean(enableQualificationRestrictedList);
    const shouldCheckEnterpriseBindLine =
        loginMethod === loginTypes.LINELOGIN && Boolean(qualificationAccountLinkPlatformLinkTarget);
    const shouldCheckApiNewRegisterMemberLimit = Boolean(enableQualificationRegistrationDate);
    const shouldCheckIsNeedVerifyMemberQualification =
        (loginMethod === loginTypes.ENTERPRISELOGIN || loginMethod === loginTypes.LINELOGIN) &&
        Boolean(enableQualificationMemberTier) &&
        thirdPartyQualificationMemberLevelPlatform !== 'kkbox';
    const shouldCheckAchievementLevel = Boolean(enableQualificationAchievementLevel);

    if (
        [
            shouldCheckIsCyberbizECMember,
            shouldCheckApiNameListLimit,
            shouldCheckEnterpriseBindLine,
            shouldCheckApiNewRegisterMemberLimit,
            shouldCheckIsNeedVerifyMemberQualification,
            shouldCheckAchievementLevel
        ].some(e => e)
    ) {
        const resp = await verityMemberQualification(promoUUID);

        const { notQualifiedType, notQualifiedErrInfo } = getNotQualifiedType(resp);
        if (notQualifiedType) {
            return { notQualifiedType, notQualifiedErrInfo };
        }
    }

    const shouldCheckKKBoxMember =
        loginMethod === loginTypes.ENTERPRISELOGIN &&
        Boolean(thirdPartyQualificationMemberLevelPlatform) &&
        thirdPartyQualificationMemberLevelPlatform === 'kkbox';

    if (shouldCheckKKBoxMember) {
        const { httpStatus } = await verifyKKboxMemberQualify(promoUUID);
        if (httpStatus === 402 || httpStatus === 400 || httpStatus === 404) {
            return {
                notQualifiedType: notQualifiedTypes.ENTERPRISE.MEMBER_KKBOX
            };
        }
    }

    return { notQualifiedType: '' };
}

const checkMemberQualifyList = [
    { checker: isErrOfCyberbizEcLimit, type: notQualifiedTypes.ENTERPRISE.CYBERBIZ_EC_MEMBER },
    { checker: isErrOfApiNameListLimit, type: notQualifiedTypes.QUALIFICATION.NAME_LIST_API },
    {
        checker: isErrOfEnterpriseBindLine,
        errInfoRetrieve: resp => ({
            redirectUrl: resp.payload?.data?.redirectUrl || null
        }),
        type: notQualifiedTypes.LINE.ENTERPRISE_MEMBER_BIND
    },
    {
        checker: isErrOfNewRegisterMemberLimit,
        type: notQualifiedTypes.QUALIFICATION.NEW_REGISTER_MEMBER
    },
    {
        checker: isErrOfMemberTier,
        type: notQualifiedTypes.QUALIFICATION.MEMBER_TIER
    },
    {
        checker: isErrOfAchievementLevel,
        type: notQualifiedTypes.QUALIFICATION.ACHIEVEMENT_LEVEL
    }
];

// 拿 verifyMemberQualification 的 response 判斷不符合資格的類型
function getNotQualifiedType(resp) {
    let notQualifiedType = '';
    let notQualifiedErrInfo = {};
    for (const { checker, type, errInfoRetrieve } of checkMemberQualifyList) {
        if (checker(resp)) {
            notQualifiedType = type;
            if (typeof errInfoRetrieve === 'function') {
                notQualifiedErrInfo = errInfoRetrieve(resp);
            }
            break;
        }
    }
    return { notQualifiedType, notQualifiedErrInfo };
}
